
import { Card, CardBody, Flex, Image, Text } from '@chakra-ui/react'
import Heading from '../heading'

interface IconCardProps {
  className?: string,
  icon?: string,
  title?: string,
  description?: string
}

function IconCard(props: IconCardProps) {

  const {
    icon,
    title,
    description
  } = props

  return (
    <Card w="full" bg="darkNavy" borderWidth={1} borderStyle="solid" borderColor="#0E1A56" borderRadius={14} boxShadow="none">
      <CardBody pt="30px" px="25px" pb="30px">
        <Flex flexDirection="column" alignItems="center" gap="10px">
          <Image src={icon} alt={title}/>
          <Flex flexDirection="column" alignItems="center" color="white" textAlign="center">
            <Heading as="h5">{title}</Heading>
            <Text size="xs" lineHeight="20px">{description}</Text>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  )
}

export default IconCard